export default {"src":"/_next/static/media/checkRecipt.495f5e11.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};